import BaseModel from '../../base';
import TeamRole from '../role';

export default class TeamPattern extends BaseModel {
  constructor(pattern = {}, url = 'team-patterns') {
    super(pattern, url);

    Object.assign(this, pattern);

    this.roles = (pattern.roles || pattern.team_roles || [])
      .map((role) => new TeamRole(role));
  }
}
